import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IOrganization {
  id: number;
  inn: string | null;
  ogrn: string;
  name: string;
  phone_number: string | null;
  email: string | null;
  snils: string | null;
  created_at: string;
  updated_at: string;
}

interface IListClientState {
  LIST_CLIENT_FOR_AGENT: IOrganization[];
  SELECTED_CLIENT_FOR_AGENT: IOrganization;
}

const initialState: IListClientState = {
  LIST_CLIENT_FOR_AGENT: [] as IOrganization[],
  SELECTED_CLIENT_FOR_AGENT: {
    id: 0,
    inn: null,
    ogrn: "",
    name: "",
    phone_number: "",
    email: "",
    snils: "",
    created_at: "",
    updated_at: "",
  },
};

// страница списка клиентов для агентов
const listClientForAgentSlice = createSlice({
  name: "LIST_CLIENT_FOR_AGENT_SLICE",
  initialState: initialState,
  reducers: {
    // обновить список клиентов для агентов
    UP_DATE_LIST_CLIENT_FOR_AGENT: (
      state,
      actions: PayloadAction<IOrganization[], string>
    ) => {
      if (actions.payload.length !== 0) {
        state.LIST_CLIENT_FOR_AGENT = actions.payload;
        state.SELECTED_CLIENT_FOR_AGENT = actions.payload[0];
      }
    },
    // изменить выбранного агента
    CHANGE_SELECTED_CLIENT_FOR_AGENT: (
      state,
      actions: PayloadAction<IOrganization, string>
    ) => {
      if (actions.payload) {
        state.SELECTED_CLIENT_FOR_AGENT = actions.payload;
      }
    },
  },
});

export const {
  UP_DATE_LIST_CLIENT_FOR_AGENT,
  CHANGE_SELECTED_CLIENT_FOR_AGENT,
} = listClientForAgentSlice.actions;

export default listClientForAgentSlice.reducer;
